/** 画面に出す日時。秒は出さない（D-248）。タイムゾーンは業務 TZ 固定（D-343）。 */

/** backend `settings.tz` / Celery / 通知トリガーと揃える */
export const APP_TIMEZONE = 'Asia/Tokyo';

const DATETIME_OPTS: Intl.DateTimeFormatOptions = {
  year: 'numeric',
  month: 'numeric',
  day: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
  timeZone: APP_TIMEZONE,
};

const DATE_OPTS: Intl.DateTimeFormatOptions = {
  year: 'numeric',
  month: 'numeric',
  day: 'numeric',
  timeZone: APP_TIMEZONE,
};

export function formatDateTime(value: string | Date | null | undefined): string {
  if (value == null || value === '') return '';
  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) return String(value);
  return date.toLocaleString('ja-JP', DATETIME_OPTS);
}

export function formatDate(value: string | Date | null | undefined): string {
  if (value == null || value === '') return '';
  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) return String(value);
  return date.toLocaleDateString('ja-JP', DATE_OPTS);
}

/** UTC ISO → `<input type="datetime-local">` 用（日本時間として表示） */
export function toDatetimeLocalValue(iso: string | Date | null | undefined): string {
  if (iso == null || iso === '') return '';
  const date = iso instanceof Date ? iso : new Date(iso);
  if (Number.isNaN(date.getTime())) return '';
  return date
    .toLocaleString('sv-SE', {
      timeZone: APP_TIMEZONE,
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      hour12: false,
    })
    .replace(' ', 'T');
}

/** datetime-local の値を日本時間として解釈し UTC ISO へ */
export function datetimeLocalToIso(local: string): string {
  const trimmed = local.trim();
  if (!trimmed) return '';
  const withSeconds = trimmed.length === 16 ? `${trimmed}:00` : trimmed;
  return new Date(`${withSeconds}+09:00`).toISOString();
}

/** datetime-local の min 属性用（日本時間の現在） */
export function nowDatetimeLocalValue(): string {
  return toDatetimeLocalValue(new Date());
}

/** datetime-local 値が日本時間の現在以前か */
export function isDatetimeLocalPast(local: string): boolean {
  if (!local.trim()) return false;
  return datetimeLocalToIso(local) <= new Date().toISOString();
}

/** UTC ISO → `<input type="date">` 用（日本時間の暦日） */
export function toDateInputValue(iso: string | Date | null | undefined): string {
  if (iso == null || iso === '') return '';
  const date = iso instanceof Date ? iso : new Date(iso);
  if (Number.isNaN(date.getTime())) return '';
  return date.toLocaleDateString('sv-SE', { timeZone: APP_TIMEZONE });
}

/** date 入力値を日本時間 0:00 として UTC ISO へ */
export function dateInputToIso(date: string): string {
  const trimmed = date.trim();
  if (!trimmed) return '';
  return datetimeLocalToIso(`${trimmed}T00:00`);
}
